// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2WQCo","validationTips":"StatementDescriptor_validationTips__3rRn4"};